import {
  Panel,
  RowSize,
  Row,
  Button,
  ButtonSize,
  ButtonVariant,
} from "@/components";
import { useNavigate } from "react-router-dom";
import { SUB_CONTRACTOR_PAGE_ROOT_PATH, SubcontractorPage } from "@/constants";
import styles from "./styles.scss";

export const CreateSubcontractor = () => {
  const navigate = useNavigate();

  const handleCreateSubcontractor = () =>
    navigate(`${SUB_CONTRACTOR_PAGE_ROOT_PATH}/${SubcontractorPage.Edit}`);

  return (
    <Panel>
      <div className={styles.emptyHeading}>Existing subcontractors</div>
      <Row size={RowSize.Small}>
        <Row size={RowSize.Small} className={styles.emptyContent}>
          <span>
            No existing subcontractors found by your request. Please make sure
            that you are entering one of following parameters:
          </span>
          <ul className={styles.emptyList}>
            <li>Company ID</li>
            <li>Arabic Name</li>
            <li>English Name</li>
          </ul>
          <span>
            If everything is correct please, and there is still no results
            please create new Sub-Contractor using button below.
          </span>
        </Row>
      </Row>
      <Row className={styles.createSubcontractorBtnContainer}>
        <Button
          variant={ButtonVariant.Secondary}
          size={ButtonSize.Small}
          className={styles.createSubcontractorBtn}
          onClick={handleCreateSubcontractor}
        >
          Create new Sub-Contractor
        </Button>
      </Row>
    </Panel>
  );
};
